import { AxiosResponse, } from 'axios'
import { put, call, takeLatest, } from 'redux-saga/effects'

import {
  GET_CONTROL_ROOM_REQUESTING_ORDER_SUMMARY,
  GET_UNASSIGNED_CONTROL_ROOM_REQUESTING_ORDERS,
  GET_ACTIVE_CONTROL_ROOM_REQUESTING_ORDERS,
  setControlRoomRequestingOrderSummary,
} from '@reducers/controlRoomRequesting'

import { authorizedAxios, } from '@utils'

import { urls, } from '@globals'

import {
  TypePagination,
  TypePaginationResult,
  ControlRoomRequestingOrder,
  ControlRoomRequestingOrderSummary,
} from '@types'

import { withAppState, } from './utils'

function* getControlRoomRequestingOrderSummary() {
  const response: AxiosResponse<ControlRoomRequestingOrderSummary> =
    yield call(authorizedAxios, urls.requestings.CONTROL_ROOM_ORDER_SUMMARY, {
      method: 'GET',
    })

  yield put(setControlRoomRequestingOrderSummary(response.data))

  return response.data
}

function* getUnassignedControlRoomRequestingOrders({ pagination, }: {
  type: string
  pagination: TypePagination
}) {
  const response: AxiosResponse<TypePaginationResult<ControlRoomRequestingOrder>> =
    yield call(authorizedAxios, urls.requestings.CONTROL_ROOM_ORDERS, {
      method: 'GET',
      params: {
        ... pagination,
        dispatch_state: 'unassigned',
      },
    })

  return response.data
}

function* getActiveControlRoomRequestingOrders({ pagination, }: {
  type: string
  pagination: TypePagination
}) {
  const response: AxiosResponse<TypePaginationResult<ControlRoomRequestingOrder>> =
    yield call(authorizedAxios, urls.requestings.CONTROL_ROOM_ORDERS, {
      method: 'GET',
      params: {
        ... pagination,
        dispatch_state: 'assigned,in_progress',
      },
    })

  return response.data
}

const controlRoomRequestingSagas = [
  takeLatest(GET_CONTROL_ROOM_REQUESTING_ORDER_SUMMARY, withAppState('GET_CONTROL_ROOM_REQUESTING_ORDER_SUMMARY', getControlRoomRequestingOrderSummary)),
  takeLatest(GET_UNASSIGNED_CONTROL_ROOM_REQUESTING_ORDERS, withAppState('GET_UNASSIGNED_CONTROL_ROOM_REQUESTING_ORDERS', getUnassignedControlRoomRequestingOrders)),
  takeLatest(GET_ACTIVE_CONTROL_ROOM_REQUESTING_ORDERS, withAppState('GET_ACTIVE_CONTROL_ROOM_REQUESTING_ORDERS', getActiveControlRoomRequestingOrders)),
]

export default controlRoomRequestingSagas
